import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const FormTranslationKeys = {
  errorRequiredFields: translationKey('form_error_required_fields'),
  fieldAddNext: translationKey('form_field_add_next'),
  fieldCost: translationKey('form_field_cost'),
  fieldCostCoveredBy: translationKey('form_field_cost_covered_by'),
  fieldCostCoveredByNone: translationKey('form_field_cost_covered_by_none'),
  fieldCostOutstanding: translationKey('form_field_cost_outstanding'),
  fieldCostSettled: translationKey('form_field_cost_settled'),
  infoRequiredFields: translationKey('form_info_required_fields'),
  saveAndFinish: translationKey('form_save_and_finish'),
  sectionCorrectiveAction: translationKey('form_section_corrective_action'),
  sectionCosts: translationKey('form_section_costs'),
  sectionFine: translationKey('form_section_fine'),
  sectionInvolvedPersonel: translationKey('form_section_involved_personel'),
  sectionIssueAnalysis: translationKey('form_section_issue_analysis'),
  sectionKeyInformation: translationKey('form_section_key_information'),
  sectionLinkedDocumentation: translationKey('form_section_linked_documentation'),
  sectionProblemRelatedAttachments: translationKey('form_section_problem_related_attachments'),
  sectionTechnicalSpecifications: translationKey('form_section_technical_specifications'),
  sectionTime: translationKey('form_section_time'),
} as const satisfies Record<string, TranslationKey>;
